


export const PREVIEW = 'preview';
export const TOOLS = 'tools';
export const SECTIONS = 'sections';
export const MODULES = 'modules';
export const OPERATES = [TOOLS, SECTIONS, MODULES];


// WEBPACK FOOTER //
// ./src/views/Setup/PageLayout/flow/edit/operateType.js